import React, { Component } from 'react'
import { Link } from 'gatsby'
import ReactMarkdown from 'react-markdown/with-html'

import Capitular from './capitular'
import Pullquote from './pullquote'
import Gallery from './gallery'
import ScrollGallery from './scrollGallery'
import VideoFullscreen from './videoFullscreen'

import bodyStyles from './articleBody.module.scss'

export class ArticleBody extends Component {
  parseLinks = props => {
    if (props.href.startsWith('/')) {
      return <Link to={props.href}>{props.children}</Link>
    } else {
      return (
        <a href={props.href} target="_blank" rel="noopener noreferrer">
          {props.children}
        </a>
      )
    }
  }

  render() {
    const { block, changeHeaderVisibility, i } = this.props

    switch (block.type) {
      case 'text':
        if (i === 0 && this.props.numChapter !== 0) {
          return (
            <>
              <Capitular
                key={`${block.id}-cap`}
                text={block.content.substring(0, 1)}
              />
              <ReactMarkdown
                className={`${bodyStyles.text} ${bodyStyles.text__firstText}`}
                key={block.id}
                source={block.content}
                escapeHtml={false}
                // linkTarget="_blank"
                renderers={{
                  link: this.parseLinks,
                }}
              />
            </>
          )
        } else {
          return (
            <ReactMarkdown
              className={bodyStyles.text}
              key={block.id}
              source={block.content}
              escapeHtml={false}
              renderers={{
                link: this.parseLinks,
              }}
            />
          )
        }

      case 'pullquote':
        return <Pullquote block={block} />

      case 'gallery':
        if (block.fullsize === true) {
          return (
            <ScrollGallery
              block={block}
              changeHeaderVisibility={changeHeaderVisibility}
            />
          )
        } else {
          return <Gallery block={block} />
        }

      case 'video':
        return (
          <VideoFullscreen
            block={block}
            changeHeaderVisibility={changeHeaderVisibility}
          />
        )

      default:
        console.warn(`Unknown block type: ${block.type}`)
        return null
    }
  }
}

export default ArticleBody
